<!-- @format -->

<resign-complete-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><a href="/menu/resign" class="terms">退会手続き</a></li>
      <li class="breadcrumb-item"><h1>退会処理の完了</h1></li>
    </ul>
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area" if={mode=='#unsubscribable'}>
      <div class="contents_block detail">
        
        <p class="important_message important_message02 margin-spacing-4_bottom">退会処理が完了しました</p>
        
        <p class="text margin-spacing-2_bottom">退会処理が完了しました。またのご利用を心よりお待ちしております。</p>
        <p class="note">※CROCO IDも退会をする場合は別途お手続きが必要です。ご希望される場合は<a href="https://id.biz-samurai.com/i/info" target="_blank">こちら</a>よりCROCO IDの退会のお手続きをしてください。</p>
        
        
      </div><!--/.contents_block-->
    </section><!--/.contents_area-->

    <section class="contents_area" if={mode=='#pausable'}>
      <div class="contents_block detail">
        
        <p class="important_message important_message02 margin-spacing-4_bottom">退会予約・休止の手続きが完了しました</p>
        
        <p class="text margin-spacing-2_bottom">受託未清算の成果報酬、及び源泉処理の都合により、退会を申請した翌年4月まで休止扱いとなります。</p>
        <p class="text margin-spacing-2_bottom">またのご利用を心よりお待ちしております。</p>
        <p class="note">※「退会予約・休止」の状態の場合は、いつでもご利用を再開することが可能です。</p>
        
        
      </div><!--/.contents_block-->
    </section><!--/.contents_area-->

  </div><!--/.contents-->
<script>
  export default {
    mode: '',
    onBeforeMount(){
      this.mode = location.hash;
    }
  }
</script>
</resign-complete-tag>
